<div class="relative group w-[300px] h-[160px] shrink-0">
  <!-- Glowing shadow behind card - solo en pantallas 2xl+ -->
  <div
    class="hidden 2xl:block absolute -inset-2 bg-card-blue-glow/15 blur-[60px] rounded-full opacity-70 group-hover:opacity-100 transition-opacity duration-500 z-0 pointer-events-none"
  ></div>

  <ui-card
    variant="contained"
    color="default"
    rounded="xl"
    padding="none"
    [border]="false"
    minHeight="160px"
    minWidth="300px"
    custom-classes="block relative w-full h-full overflow-hidden backdrop-blur-xl bg-gradient-to-br from-card-blue-from/70 via-card-blue-via/60 to-card-blue-to/70 border border-card-blue-border/40 shadow-card-blue 2xl:shadow-card-2xl hover:shadow-card-blue-hover 2xl:hover:shadow-card-2xl-hover hover:-translate-y-0.5 transition-all duration-300 z-10"
  >
    <div class="luces-difusas">
      <div class="luces-difusas-horizontal">
        <span class="luz-difusa luz-difusa-cardensity"></span>
      </div>
    </div>
    <!-- Glow -->
    <div
      class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[220px] h-[140px] bg-[radial-gradient(circle,rgba(249,160,27,0.45),transparent_70%)] blur-[80px] opacity-80 pointer-events-none z-0"
    ></div>

    <div class="relative px-4 py-5 h-full flex items-center justify-center">
      <div class="flex items-center gap-4">
        <!-- Gráfica -->
        <div class="relative w-[105px] h-[105px] flex-shrink-0">
          <svg
            width="105"
            height="105"
            viewBox="0 0 105 105"
            class="drop-shadow-xl -rotate-90"
          >
            <circle
              cx="52.5"
              cy="52.5"
              r="42"
              fill="none"
              stroke="#F9A01B"
              stroke-width="12"
              stroke-dasharray="92 264"
              stroke-linecap="round"
            />

            <circle
              cx="52.5"
              cy="52.5"
              r="42"
              fill="none"
              stroke="#2383B6"
              stroke-width="12"
              stroke-dasharray="111 264"
              stroke-dashoffset="-92"
              stroke-linecap="round"
            />

            <circle
              cx="52.5"
              cy="52.5"
              r="42"
              fill="none"
              stroke="#8A38F5"
              stroke-width="12"
              stroke-dasharray="32 264"
              stroke-dashoffset="-203"
              stroke-linecap="round"
            />

            <circle
              cx="52.5"
              cy="52.5"
              r="42"
              fill="none"
              stroke="#FF0090"
              stroke-width="12"
              stroke-dasharray="29 264"
              stroke-dashoffset="-235"
              stroke-linecap="round"
            />
          </svg>

          <div class="absolute inset-0 flex items-center justify-center">
            <p
              class="text-[8px] text-gray-200 font-medium leading-[1.2] text-center"
            >
              Densidad de<br />grupos
            </p>
          </div>
        </div>

        <!-- Leyenda -->
        <div class="flex flex-col gap-0.5">
          <div class="flex items-center gap-1.5">
            <span class="w-2 h-2 rounded-full bg-[#F9A01B]"></span>
            <span class="text-[12px] font-bold text-white"
              >{{ frontend }}%</span
            >
            <span class="text-[12px] text-gray-200">Frontend</span>
          </div>

          <div class="flex items-center gap-1.5">
            <span class="w-2 h-2 rounded-full bg-[#2383B6]"></span>
            <span class="text-[12px] font-bold text-white">{{ backend }}%</span>
            <span class="text-[12px] text-gray-200">Backend</span>
          </div>

          <div class="flex items-center gap-1.5">
            <span class="w-2 h-2 rounded-full bg-[#8A38F5]"></span>
            <span class="text-[12px] font-bold text-white"
              >{{ transversal }}%</span
            >
            <span class="text-[12px] text-gray-200">Transversal</span>
          </div>

          <div class="flex items-center gap-1.5">
            <span class="w-2 h-2 rounded-full bg-[#FF0090]"></span>
            <span class="text-[12px] font-bold text-white">{{ design }}%</span>
            <span class="text-[12px] text-gray-200">Diseño</span>
          </div>
        </div>
      </div>
    </div>
  </ui-card>
</div>
